<template>
  <section class="mt-5">
    <h2>会員サイトご利用登録</h2>
    <div class="form-navi mb-5">
      <ul class="d-flex">
        <li>入力</li>
        <li class="here">確認</li>
        <li>送信完了</li>
      </ul>
    </div>
    <div class="form-content">
      <p>
        入力内容のご確認をお願いします。<br />
        入力内容に誤りが無い場合は「仮登録する」ボタンを押してください。入力内容に誤りが有る場合は「訂正する」ボタンを押してください。
      </p>
      <div class="form-member my-5">
        <div class="inner">
          <dl>
            <dt>会員番号</dt>
            <dd>
              <label id="Userid">{{ userID }}</label>
            </dd>
            <dt>パスワード</dt>
            <dd>
              <label id="PasswordDummy">●●●●●●●●●●●●</label>
              <input type="hidden" id="Password" />
            </dd>
            <dt>メールアドレス</dt>
            <dd>
              <label id="Mailaddress">{{ mailAddress }}</label>
            </dd>
            <dt>電話番号下四桁</dt>
            <dd>
              <label id="telUnder">{{ telUnder }}</label>
              <input type="hidden" id="telUnder" />
            </dd>
            <dt>実績メールの配信</dt>
            <dd>
              <label id="Interval">
                <div v-if="wantResults">希望しない</div>
                <div v-else>希望する</div>
              </label>
            </dd>
            <dt>お知らせメールの配信</dt>
            <dd>
              <label id="Info">
                <div v-if="wantInfo">希望しない</div>
                <div v-else>希望する</div>
              </label>
            </dd>
          </dl>
          <p class="my-5">
            「仮登録する」ボタンを押した後に、ご入力頂いたメールアドレス宛に「本登録お手続きのお願い」メールをお送りします。<br />
            本登録終了後に入力頂いたメールアドレスが本サイトにて有効になります。<br />
            メールが届きましたら、メールの内容に従い、本登録をお願いします。
          </p>

          <div class="box-p-20 text-center">
            <button
              v-on:click="putData"
              type="submit"
              class="confirm-01 clear"
              id="Update"
            >
              仮登録する
            </button>
          </div>
          <div class="box-p-20 text-center">
              <button v-on:click="returnPage" type="submit" class="back-01" id="Cancel">
                訂正する
              </button>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div>
    <p class="text-center">株式会社マナビス化粧品</p>
    <p class="text-center">
      ◆〒279-0032 千葉県浦安市千鳥15-9<br />
      ◆お問い合わせ:0120-268-510<br />
      ◆商品相談窓口:0120-649-510
    </p>
  </div>
</template>
<script>
import Store from "@/modules/Store";
let store = new Store();
import Authenticate from "@/modules/Authenticate";
let auth = new Authenticate();
import Message from "@/modules/Message";
import Request from "@/modules/Request";
let request = new Request();
export default {
  data() {
    return {
      mailAddress: "sfdafdsa@gasdf.co",
      password: "",
      userID: "testID",
      telUnder:"",
      birthMonth: "1",
      birthDay: "20",
      wantResults: false,
      wantInfo: false,
    };
  },
  mounted() {
    window.scroll(0, 0);
    if (!this.getData()) {
      Message.error().fire({
        title: "不正なアクセスです。",
        didClose: () => {
          this.$router.push("/register");
        },
      });
    }
  },
  methods: {
    getData() {
      let json = store.get(auth.getNoLoginUid());
      if(json == "") return false;
      let ob = JSON.parse(json);
      if (ob.mailAddress == "") return false;
      this.mailAddress = ob.mailAddress;
      if (ob.password == "") return false;
      this.password = ob.password;
      if (ob.userID == "") return false;
      this.userID = ob.userID;
      if (ob.telUnder == "") return false;
      this.telUnder = ob.telUnder;
      this.wantResults = ob.chkInterval;
      this.wantInfo = ob.chkInfo;
      return true;
    },
    putData() {
      Message.confirm()
        .fire({
          title: "メールアドレス、パスワードを登録します。よろしいですか？",
        })
        .then((result) => {
          if (result.value) {
            let params =
              this.userID +
              "," +
              this.wantResults +
              "," +
              this.wantInfo +
              "," +
              this.mailAddress +
              "," +
              this.password +
              "," +
              this.telUnder
            let requestParams = request.createParams(
              "webMdlMemberInfo",
              "setTempMailSettingByTelNo",
              [params]
            );
            request
              .create()
              .post("", requestParams)
              .then(() => {
                this.$router.push("/register/end");
              });
          }
        });
    },
    returnPage() {
      Message.confirm()
        .fire({
          title: "メールアドレス入力画面に戻ります。よろしいですか？",
        })
        .then((result) => {
          if (result.value) {
            this.$router.push("/register");
          }
        });
    },
  },
};
</script>
